export const readdScripts = function (element, target = null) {
  if (!target) {
    target = document.body;
  }

  // Query element for scripts.
  const scripts = element.querySelectorAll('script');
  const scriptsExternal = [];
  const scriptsInline = [];
  for (const script of scripts) {
    // Create script element.
    const scriptElement = document.createElement('script');

    // Mark as nc partial script.
    scriptElement.setAttribute('data-partial-script', true);
    // Transfer attributes.
    for (const attributeName of script.getAttributeNames()) {
      scriptElement.setAttribute(attributeName, script.getAttribute(attributeName));
    }
    if (script.hasAttribute('src')) {
      // Add script to list.
      scriptsExternal.push(scriptElement);
    } else {
      // Bring over inline content.
      scriptElement.innerHTML = script.innerHTML;

      // Add script to list.
      scriptsInline.push(scriptElement);
    }
    // Remove existing script.
    script.remove();
  }

  // Add all inline scripts.
  const addInlineScripts = () => {
    for (const scriptInline of scriptsInline) {
      // Listen for errors and log the script contents on error so we know where it came from.
      const errorHandler = () => {
        console.warn('Error in inline script:\n', scriptInline.textContent);
      };
      window.addEventListener('error', errorHandler);
      target.appendChild(scriptInline);
      window.removeEventListener('error', errorHandler);
    }
  };
  let scriptsToLoad = scriptsExternal.length;
  if (scriptsToLoad > 0) {
    // Add and wait for external scripts to load first.
    for (const scriptExternal of scriptsExternal) {
      const decrementScript = () => {
        scriptsToLoad--;
        if (scriptsToLoad <= 0) {
          addInlineScripts();
        }
      };
      scriptExternal.addEventListener('error', decrementScript, {
        once: true
      });
      scriptExternal.addEventListener('load', decrementScript, {
        once: true
      });
      target.appendChild(scriptExternal);
    }
  } else {
    // If no external scripts to load add inline scripts immediately.
    addInlineScripts();
  }
};
export default readdScripts;